import { parse as queryStringParser } from "query-string";

export function getGroupIdHashByUrlLocation(url: Location): string {
  const byQueryString = queryStringParser(url.search, { decode: false });
  if (byQueryString?.groupId) {
    return byQueryString?.groupId as string;
  }
  const params = url.href.split("/");
  const groupPosition = params.indexOf("group");
  const groupIdByRoute = groupPosition !== -1 ? params[groupPosition + 1] : "";

  return groupIdByRoute;
}
